import type { WorkFilters } from "@/utils/gallery";

interface FilterGroup {
  key: keyof WorkFilters;
  label: string;
  options: string[];
}

interface FilterSidebarProps {
  groups: FilterGroup[];
  filters: WorkFilters;
  onToggle: (key: keyof WorkFilters, value: string) => void;
  onReset: () => void;
  activeCount: number;
}

export default function FilterSidebar({
  groups,
  filters,
  onToggle,
  onReset,
  activeCount,
}: FilterSidebarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
          <i className="ri-filter-3-line text-primary-500" />
          筛选条件
        </h2>
        {activeCount > 0 && (
          <button
            type="button"
            onClick={onReset}
            className="whitespace-nowrap text-xs text-primary-600 transition-colors hover:text-primary-700"
          >
            重置（{activeCount}）
          </button>
        )}
      </div>

      <div className="mt-5 space-y-6">
        {groups.map((group) => (
          <div key={group.key}>
            <h3 className="mb-3 text-xs font-medium tracking-widest text-foreground-500">
              {group.label}
            </h3>
            <div className="flex flex-col gap-2">
              {group.options.map((option) => {
                const checked = filters[group.key].includes(option);
                return (
                  <label
                    key={option}
                    className="flex cursor-pointer items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    <span
                      className={`flex h-4 w-4 items-center justify-center rounded border transition-colors ${
                        checked
                          ? "border-primary-500 bg-primary-500 text-background-50"
                          : "border-background-300"
                      }`}
                    >
                      {checked && <i className="ri-check-line text-xs" />}
                    </span>
                    <input
                      type="checkbox"
                      className="sr-only"
                      checked={checked}
                      onChange={() => onToggle(group.key, option)}
                    />
                    {option}
                  </label>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}